import list from "./list";
import notification from "./notification";

export default `
  ${list}
  ${notification}
`;
